export default "__VITE_ASSET__0318c4c7__"